import FilterChip from './ui/FilterChip';
import { VENUE_FILTERS, eventMatchesVenueFilter } from '../utils/venueFilters';

export { VENUE_FILTERS, eventMatchesVenueFilter };

export function VenueTierFilter({ selectedFilter, onFilterChange, pill = false }) {
  return (
    <div className="flex gap-2 flex-wrap">
      {VENUE_FILTERS.map((filter) => (
        <FilterChip
          key={filter.value}
          pill={pill}
          selected={selectedFilter === filter.value}
          onClick={() => onFilterChange(filter.value)}
        >
          {filter.label}
        </FilterChip>
      ))}
    </div>
  );
}
